import config from '../../config/local';

class ConfigService {
    getAppEnv() {
        return config.ENV === 'DEV' ? 'stage' : 'production';
    }
}

export const configService = new ConfigService();